import { render, staticRenderFns } from "./backoffice-contratos.vue?vue&type=template&id=089f0cde&scoped=true"
import script from "./backoffice-contratos.vue?vue&type=script&lang=ts"
export * from "./backoffice-contratos.vue?vue&type=script&lang=ts"
import style0 from "./backoffice-contratos.vue?vue&type=style&index=0&id=089f0cde&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "089f0cde",
  null
  
)

export default component.exports